import { Controller } from "@hotwired/stimulus";
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";

export default class extends Controller {
  static values = {
    urls: Array,
  };

  connect() {}

  open(e) {
    const index = e.currentTarget.dataset.index;

    if (this.lightbox) {
      this.lightbox.openAt(index);
      return;
    }

    const elements = this.urlsValue.map((item) => {
      if (item.type === "video") {
        return {
          href: item.url,
          type: "video",
        };
      }

      return {
        href: item.url,
        type: "image",
      };
    });

    this.lightbox = GLightbox({
      elements: elements,
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
      startAt: index,
    });
    this.lightbox.open();
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy();
    }
  }
}
